<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Input
  } from "sveltestrap";
  import { ListGroup, ListGroupItem, Spinner } from "sveltestrap";
  import { onMount, getContext } from "svelte";
  export let open;
  export let toggle;
  export let data;
  export let staffid;
  export let newdate;
  let job = data.Result.New_JobName;
  let deliverable = null;
  let deliverablename = data.Result.New_DeliverableName;
  let deliverableid = data.Result.New_DeliverableId;
  let taskid = data.Result.New_CostcentreId;
  let taskname = data.Result.New_Costcentrename;
  let taskArray = null;
  let notes = data.Result.Notes;
  let monday = parseFloat(data.Result.ActualworkhrsMonday).toFixed(2);
  let tuesday = parseFloat(data.Result.ActualworkhrsTuesday).toFixed(2);
  let wednesday = parseFloat(data.Result.ActualworkhrsWednesday).toFixed(2);
  let thursday = parseFloat(data.Result.ActualworkhrsThursday).toFixed(2);
  let friday = parseFloat(data.Result.ActualworkhrsFriday).toFixed(2);
  let saturday = parseFloat(data.Result.ActualworkhrsSaturday).toFixed(2);
  let sunday = parseFloat(data.Result.ActualworkhrsSunday).toFixed(2);
  let jobsArray = null;
  let deliverableArray = null;
  let job_id = data.Result.New_JobId;
  let focus = true;
  let showDeliverable = false;
  let completed = false;
  let submitEdit = false;
  let fetching_job = false;
  let monday_show = false;
  let tuesday_show = false;
  let wednesday_show = false;
  let thursday_show = false;
  let friday_show = false;
  let saturday_show = false;
  let sunday_show = false;
  let monday_note = data.Result.MondayNotes;
  let tuesday_note = data.Result.TuesdayNotes;
  let wednesday_note = data.Result.WednesdayNotes;
  let thursday_note = data.Result.ThursdayNotes;
  let friday_note = data.Result.FridayNotes;
  let saturday_note = data.Result.SaturdayNotes;
  let sunday_note = data.Result.SundayNotes;

  const { getCurrentTimesheetId } = getContext('timesheet');

  onMount(() => {
    getDefaultDeliverable();
    getDefaultTask();
  });

  async function getDefaultDeliverable() {
    const res = await fetch("/timesheetapi/BuildDeliverables?jobId=" + job_id);
    const json = await res.json();
    deliverableArray = json;
  }

  async function getDefaultTask() {
    const res = await fetch(
      "/timesheetapi/BuildCostCenter?deliverableId=" + deliverableid
    );
    const json = await res.json();
    taskArray = json;
  }

  async function getJobs(job) {
    fetching_job = true;
    const res = await fetch("/timesheetapi/BuildJob?prefixText=" + job);
    const json = await res.json();
    fetching_job = false;
    jobsArray = json;
  }

  async function getDeliverable(job_id) {
    const res = await fetch("/timesheetapi/BuildDeliverables?jobId=" + job_id);
    const json = await res.json();
    deliverableArray = json;
  }

  async function getTask(deliverable_id) {
    const res = await fetch(
      "/timesheetapi/BuildCostCenter?deliverableId=" + deliverable_id
    );
    const json = await res.json();
    taskArray = json;
    taskid = taskArray[0].costId;
  }

  async function submitNewtimesheet() {
    const editall_data = {
      JobId: job_id,
      JobName: job,
      TimesheetId: getCurrentTimesheetId(),
      DeliverableId: deliverableid,
      TaskId: taskid,
      SundayHours: sunday,
      SaturdayHours: saturday,
      FridayHours: friday,
      ThursdayHours: thursday,
      WednesdayHours: wednesday,
      TuesdayHours: tuesday,
      MondayHours: monday,
      CheckCompleted: completed,
      Prev_JobId: data.Result.New_JobId,
      Prev_JobName: data.Result.New_JobName,
      Prev_TaskId: data.Result.New_CostcentreId,
      Prev_DeliverableId: data.Result.New_DeliverableId,
      Prev_Notes: data.Result.Notes,
      TaskArrayId: data.Result.ActivityId,
      weekStart: newdate,
      StaffId: staffid,
      MondayNotes: monday_note,
      TuesdayNotes: tuesday_note,
      WednesdayNotes: wednesday_note,
      ThursdayNotes: thursday_note,
      FridayNotes: friday_note,
      SaturdayNotes: saturday_note,
      SundayNotes: sunday_note
    };
    const res = await fetch("/timesheetapi/EditAllTimeCard", {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(editall_data)
    });
    const json = res.status;
    // toggle();
    if (json === 200) {
      document.getElementById("btn-search").click();
    }
  }

  function handleChangeJob(e) {
    job = e.target.value;
    getJobs(job);
  }

  function handlePassId(id, name) {
    focus = false;
    job_id = id;
    job = name;
    showDeliverable = true;
    getDeliverable(id);
  }

  function handleChangeDeliverable(e) {
    deliverableid = e.target.value;
    getTask(deliverableid);
  }

  function handleChangeTask(e) {
    taskid = e.target.value;
  }

  const onFocus = () => (focus = true);

  function onCheck(e) {
    completed = e.target.checked;
  }
  let error = false;
  let error_message = "";
  function handleSubmit() {
    if (
      monday === undefined ||
      tuesday === undefined ||
      wednesday === undefined ||
      thursday === undefined ||
      friday === undefined ||
      saturday === undefined ||
      sunday === undefined
    ) {
      error = true;
      error_message = "Fields should not be empty except (Notes)";
    } else if (
      monday > 24 ||
      tuesday > 24 ||
      wednesday > 24 ||
      thursday > 24 ||
      friday > 24 ||
      saturday > 24 ||
      sunday > 24
    ) {
      error = true;
      error_message = "Hours must not exceed to 24";
    } else if (taskid === " " || job === "") {
      error = true;
      error_message = "Fields should be empty except (Notes)";
    } else {
      error = false;
      submitEdit = true;
      submitNewtimesheet();
    }
  }

  function handleCancel() {
    job = data.Result.New_JobName;
    deliverable = null;
    deliverablename = data.Result.New_DeliverableName;
    deliverableid = data.Result.New_DeliverableId;
    taskid = data.Result.New_CostcentreId;
    taskname = data.Result.New_Costcentrename;
    taskArray = null;
    notes = data.Result.Notes;
    monday = parseFloat(data.Result.ActualworkhrsMonday).toFixed(2);
    tuesday = parseFloat(data.Result.ActualworkhrsTuesday).toFixed(2);
    wednesday = parseFloat(data.Result.ActualworkhrsWednesday).toFixed(2);
    thursday = parseFloat(data.Result.ActualworkhrsThursday).toFixed(2);
    friday = parseFloat(data.Result.ActualworkhrsFriday).toFixed(2);
    saturday = parseFloat(data.Result.ActualworkhrsSaturday).toFixed(2);
    sunday = parseFloat(data.Result.ActualworkhrsSunday).toFixed(2);
    jobsArray = null;
    deliverableArray = null;
    job_id = data.Result.New_JobId;
    focus = true;
    showDeliverable = false;
    completed = false;
    error = false;
    toggle();
  }
</script>

<style>
  label {
    font-size: 18px;
    display: inline-block;
    font-weight: 500;
  }
  .btn-show-note {
    background-color: white;
    color: black;
    border: 1px solid #b2bec3;
    padding: 0px 10px;
    border-radius: 5px;
    float: right;
  }
  select {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  .row-container {
    margin-bottom: 10px;
  }
  select:disabled {
    background-color: #f1f2f6;
    cursor: not-allowed;
  }
  .listgroup-style {
    overflow-y: scroll;
    max-height: 400px;
    position: absolute;
    border: 1px solid #4bcffa;
  }
  .listgroup-style::-webkit-scrollbar {
    display: none;
  }
  .listitem-style {
    width: auto;
    max-width: 465.5px;
    min-width: 465.5px;
  }
  .row-container-checkbox {
    display: flex;
  }
  .input-checkbox {
    width: 10%;
    margin-top: 8px;
  }
   input:focus{
        border: 2px solid #706c6c;
  }
  
</style>

<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>Edit All Timesheet</ModalHeader>
  <ModalBody>
    <div class="newtimesheet-modal-body">
      <div class="row-container">
        <label>Job</label>
        <input
          type="text"
          placeholder="Job"
          value={job}
          on:keyup={handleChangeJob}
          on:focus={onFocus} 
          autofocus/>
        {#if fetching_job}
          <Spinner
            size="sm"
            style="position: absolute; margin-left: -23px; margin-top: 15px;
            color: #b2bec3" />
        {/if}
        <input type="text" value={job_id} hidden />
        {#if jobsArray !== null}
          {#if job !== ''}
            {#if focus}
              <div class="listgroup-style">
                <ListGroup>
                  {#each jobsArray as job}
                    <div class="listitem-style">
                      <ListGroupItem
                        tag="button"
                        action
                        key={job.jobId}
                        on:click={handlePassId(job.jobId, job.jobName)}>
                        {job.jobName}
                      </ListGroupItem>
                    </div>
                  {/each}
                </ListGroup>
              </div>
            {/if}
          {/if}
        {/if}
      </div>
      <div class="row-container">
        <label>Deliverable</label>
        <select value={deliverableid} on:change={handleChangeDeliverable}>
          {#if deliverableArray !== null}
            {#each deliverableArray as deliverable}
              <option
                value={deliverable.deId}
                selected={deliverable.deName === deliverablename ? true : false}>
                {deliverable.deName}
              </option>
            {/each}
          {:else}
            <option value={deliverableid}>{deliverablename}</option>
          {/if}
        </select>
      </div>
      <div class="row-container">
        <label>Task</label>
        <select value={taskid} on:change={handleChangeTask}>
          {#if taskArray !== null}
            {#each taskArray as task}
              <option
                value={task.costId}
                selected={task.costName === taskname ? true : false}>
                {task.costName}
              </option>
            {/each}
          {:else}
            <option value={taskid}>{taskname}</option>
          {/if}
        </select>
      </div>
      <div class="row-container">
        <label>Monday</label>
        <button
          class="btn-show-note"
          on:click={() => (monday_show = !monday_show)}>
          {monday_show ? '- Hide note' : '+ Show Note'}
        </button>
        <input type="number" placeholder="Monday" bind:value={monday} />
        {#if monday_show}
          <Input
            type="textarea"
            placeholder="Monday notes (optional)"
            style="margin-top: 13px;"
            bind:value={monday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Tuesday</label>
        <button
          class="btn-show-note"
          on:click={() => (tuesday_show = !tuesday_show)}>
          {tuesday_show ? '- Hide note' : '+ Show Note'}
        </button>
        <input type="number" placeholder="Tue" bind:value={tuesday} />
        {#if tuesday_show}
          <Input
            type="textarea"
            placeholder="Tuesday notes (optional)"
            style="margin-top: 13px;"
            bind:value={tuesday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Wednesday</label>
        <button
          class="btn-show-note"
          on:click={() => (wednesday_show = !wednesday_show)}>
          {wednesday_show ? '- Hide note' : '+ Show Note'}
        </button>
        <input type="number" placeholder="Wed" bind:value={wednesday} />
        {#if wednesday_show}
          <Input
            type="textarea"
            placeholder="Wednesday notes (optional)"
            style="margin-top: 13px;"
            bind:value={wednesday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Thursday</label>
        <button
          class="btn-show-note"
          on:click={() => (thursday_show = !thursday_show)}>
          {thursday_show ? '- Hide Note' : '+ Show Note'}
        </button>
        <input type="number" placeholder="Thu" bind:value={thursday} />
        {#if thursday_show}
          <Input
            type="textarea"
            placeholder="Thursday notes (optional)"
            style="margin-top: 13px;"
            bind:value={thursday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Friday</label>
        <button
          class="btn-show-note"
          on:click={() => (friday_show = !friday_show)}>
          {friday_show ? '- Hide note' : '+ Show Note'}
        </button>
        <input type="number" placeholder="Fri" bind:value={friday} />
        {#if friday_show}
          <Input
            type="textarea"
            placeholder="Friday notes (optional)"
            style="margin-top: 13px;"
            bind:value={friday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Saturday</label>
        <button
          class="btn-show-note"
          on:click={() => (saturday_show = !saturday_show)}>
          {saturday_show ? '- Hide note' : '+ Show Note'}
        </button>
        <input type="number" placeholder="Sat" bind:value={saturday} />
        {#if saturday_show}
          <Input
            type="textarea"
            placeholder="Saturday notes (optional)"
            style="margin-top: 13px;"
            bind:value={saturday_note} />
        {/if}
      </div>
      <div class="row-container">
        <label>Sunday</label>
        <button
          class="btn-show-note"
          on:click={() => (sunday_show = !sunday_show)}>
          {sunday_show ? '- Hide note' : '+ Show Note'}
        </button>
        <input type="number" ys placeholder="Sun" bind:value={sunday} />
        {#if sunday_show}
          <Input
            type="textarea"
            placeholder="Sunday notes (optional)"
            style="margin-top: 13px;"
            bind:value={sunday_note} />
        {/if}
      </div>
      <div class="row-container-checkbox">
        <input on:change={onCheck} class="input-checkbox" type="checkbox" />
        <label>Completed</label>
      </div>
      {#if error}
        <div
          class="row-container"
          style="text-align:center; background-color: #eb4d4b; color: white;">
          <p>{error_message}</p>
        </div>
      {/if}
    </div>
  </ModalBody>
  <ModalFooter>
    {#if submitEdit}
      <Button
        color="primary"
        style="cursor: not-allowed; opacity: 0.5"
        on:click={handleSubmit}
        disabled>
        <Spinner size="sm" />
        Saving
      </Button>
    {:else}
      <Button color="primary" on:click={handleSubmit}>Save</Button>
    {/if}
    <Button color="secondary" on:click={handleCancel}>Cancel</Button>
  </ModalFooter>
</Modal>
